export enum ClaraEventPayloadType {
  TOKEN = 'token',
  DONE = 'done',
  CLARIFICATION = 'clarification',
  ERROR = 'error'
}
